import React, { Component } from 'react';
import {MasterLayout} from 'layout';
import { Input, DropDown } from 'components/tt-forms/common';
import DataTable from 'components/data-table';
import { RowItemDSThongBao } from 'modules/thanh-tra-trung/datatable';
import { header } from 'constants/table';
import {TrangChu, LetterProcessingWorkFlow} from 'api';

class DanhSachThongBao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      soQuyetDinh: '',
      namThanhTra: '',
      dataDSThongBao: [],
      pageData: {
        number: 0,
        size: 10,
        totalElements: 0
      },
    };
  }

  onChange() {

  }

  componentDidMount() {
    this.getNotify();
  }

  handleChangePageSize(size) {
    this.setState({
      pageData: {
        ...this.state.pageData,
        size: size,
        number: 0
      }
    },() => {
      this.getNotify();
    })
  }

  getNotify() {
    let params = {
      page: this.state.pageData.number,
      size: this.state.pageData.size,
    };
    TrangChu.actions.getThongBao.request(null, params).then(res => {
      if (res.data._embedded) {
        this.setState({
          dataDSThongBao: res.data._embedded.thongBaos,
          pageData: res.data.page
        })
      } else {
        this.setState({
          pageData: {
            number: 0,
            size: 10,
            totalElements: 0
          }
        });
      }
    }).catch(err => {

    });
  }

  handlePageClick(page) {
    this.state.pageData.number = page.selected;
    this.getNotify();
  }

  getDanhSachThongBao() {}

  render() {
    return (
      <MasterLayout routerName={this.props.route.name}>
        <div className="center reception-container" ref="dstb">
          <div className="top-content">
            <div className="left-content">
              <p className="title-18"><i className="tt tt-thanh-tra"></i>Danh sách thông báo</p>
            </div>
          </div>
          <div className="bottom-content">
            <div className='wrap-block pl15 pr15 pt20'>
              <form onSubmit={this.getDanhSachThongBao.bind(this, true)}>
                <div className='row pl10 pr10'>
                  <div className='col-83 no-gutter'>
                    <Input className='col-40' label='Đối tượng thanh tra' placeholder='Nhập tên đối tượng thanh tra tìm kiếm...' value={this.state.soQuyetDinh} onChange={this.onChange.bind(this, 'soQuyetDinh')} name='soQuyetDinh'/>
                  <div className='col-20 mb0-18 search-thanh-tra'>
                  <button className='btn-green'>
                    <i className='tt-search'></i>Tìm kiếm
                  </button>
                  </div>
                  </div>
                </div>
              </form>
              <div className='row'>
                <span className="line-border"></span>
              </div>
            </div>
            <DataTable
              header={header.thanhTraTrung.DSTB}
              dataList={this.state.dataDSThongBao}
              hideButtonExport
              pageData={this.state.pageData}
              parent={this}
              search
              tableLoading={this.state.tableLoading}>
              <RowItemDSThongBao/>
            </DataTable>
          </div>
        </div>
      </MasterLayout>
    )
  }
}

export default DanhSachThongBao


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra-trung/DanhSachThongBao.jsx